import PubSub from '../PubSub'

export interface SearchDetails {
  searchQuery: string
  searchAlgoliaQueryId: string
  searchAlgoliaAutosuggestQueryId: string
  shouldTriggerSearchCompleteEvent: boolean
}

interface SiteState {
  isScrollingDown: boolean
  isScrolledDown: boolean
  isSearchMode: boolean
  searchDetails: SearchDetails
}

class SiteStateManager extends PubSub {
  private state: SiteState

  constructor() {
    super()
    this.state = {
      isScrollingDown: false,
      isScrolledDown: false,
      isSearchMode: false,
      searchDetails: {
        searchQuery: '',
        searchAlgoliaQueryId: '',
        searchAlgoliaAutosuggestQueryId: '',
        shouldTriggerSearchCompleteEvent: false,
      },
    }
  }

  setIsScrollingDown = (val: boolean) => {
    this.state.isScrollingDown = val
    this.publish()
  }

  getIsScrollingDown = () => {
    return this.state.isScrollingDown
  }

  setIsScrolledDown = (val: boolean) => {
    this.state.isScrolledDown = val
    this.publish()
  }

  getIsScrolledDown = () => {
    return this.state.isScrolledDown
  }

  setIsSearchMode = (val: boolean) => {
    this.state.isSearchMode = val
    this.publish()
  }

  getIsSearchMode = () => {
    return this.state.isSearchMode
  }

  setSearchAlgoliaQueryId = ({
    searchQuery,
    searchAlgoliaQueryId,
  }: {
    searchQuery: string
    searchAlgoliaQueryId: string
  }) => {
    const newSearchDetails = {
      ...this.state.searchDetails,
    }
    if (searchQuery) {
      newSearchDetails.searchQuery = searchQuery
    }
    if (searchAlgoliaQueryId) {
      newSearchDetails.searchAlgoliaQueryId = searchAlgoliaQueryId
    }
    this.state.searchDetails = newSearchDetails
    this.publish()
  }

  setSearchAlgoliaAutosuggestQueryId = ({
    searchQuery,
    searchAlgoliaAutosuggestQueryId,
  }: {
    searchQuery: string
    searchAlgoliaAutosuggestQueryId: string
  }) => {
    const newSearchDetails = {
      ...this.state.searchDetails,
    }
    if (searchQuery) {
      newSearchDetails.searchQuery = searchQuery
    }
    if (searchAlgoliaAutosuggestQueryId) {
      newSearchDetails.searchAlgoliaAutosuggestQueryId = searchAlgoliaAutosuggestQueryId
    }
    this.state.searchDetails = newSearchDetails
    this.publish()
  }

  getSearchDetails = () => {
    return this.state.searchDetails
  }

  setShouldTriggerSearchCompleteEvent = (val: boolean) => {
    this.state.searchDetails.shouldTriggerSearchCompleteEvent = val
    this.publish()
  }
}

const siteStateManager: SiteStateManager = SiteStateManager.getInstance('siteStateManager')

export default siteStateManager
